export function statusClass(status) {
    if (status === 0) {
        return '--no';
    } else if (status === 1) {
        return '--progress';
    } else if (status > 1) {
        return '--pass';
    }
    return '';
}
